import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { SupportedLeadCardType } from '~/cards/types/supportedLeadCardTypes';

// The individual PLP tiles shown at every Nth position
export const PLP_MODULE_GROUP_TAGS: Record<SupportedLeadCardType, string> = {
  DETAILS: 'invites-plp-enclosure',
  ENCLOSURE: 'invites-plp-enclosure',
  HOLIDAY: 'invites-plp-holiday',
  INVITATION: 'invites-plp-invitation',
  MENU: 'invites-plp-menu',
  PLACE: 'invites-plp-placecard',
  PROGRAM: 'invites-plp-program',
  NAPKIN: 'invites-plp-napkin',
  SIGNAGE: 'invites-plp-signage',
  STICKER: 'invites-plp-sticker',
  SAVE_THE_DATE: 'invites-plp-savethedate',
  DIGITAL_SAVE_THE_DATE: 'invites-plp-digitalsavethedate',
  CHANGE_THE_DATE: 'invites-plp-changethedate',
  THANK_YOU: 'invites-plp-thankyou',
  MATCHING_SUITES: 'invites-plp-matching-suites',
  [CARD_TYPE_MAP.weddingShower]: 'invites-plp-wedding-shower',
  [CARD_TYPE_MAP.tableNumber]: 'invites-plp-table-number',
  [CARD_TYPE_MAP.paperAddOns]: 'invites-plp-paperaddons',
  [CARD_TYPE_MAP.bellyBand]: 'invites-plp-paperaddons',
  [CARD_TYPE_MAP.vellumJacket]: 'invites-plp-paperaddons',
  [CARD_TYPE_MAP.waxSeal]: 'invites-plp-paperaddons',
} as const;

// The carousel tile shown on preauth PLP
export const PLP_PROMO_MODULE_GROUP_TAGS_PRE_AUTH: Record<
  SupportedLeadCardType,
  string | undefined
> = {
  MATCHING_SUITES: undefined, // Module isn't displayed on the matching suites page
  SAVE_THE_DATE: 'paper-plp-promos-savethedate-preauth',
  DIGITAL_SAVE_THE_DATE: undefined,
  INVITATION: 'paper-plp-promos-invitation-preauth',
  WEDDING_SHOWER_INVITATION: 'paper-plp-promos-wedding-shower-preauth',
  PLACE: 'paper-plp-promos-placecard-preauth',
  MENU: 'paper-plp-promos-menu-preauth',
  PROGRAM: 'paper-plp-promos-program-preauth',
  NAPKIN: 'paper-plp-promos-napkins-preauth',
  SIGNAGE: 'paper-plp-promos-weddingsigns-preauth',
  STICKER: 'paper-plp-promos-stickers-preauth',
  THANK_YOU: 'paper-plp-promos-thankyou-preauth',
  ENCLOSURE: undefined, // On the PLP, the type will always be DETAILS
  DETAILS: 'paper-plp-promos-enclosure-preauth',
  HOLIDAY: 'paper-plp-promos-holiday-preauth',
  TABLE_NUMBER: 'paper-plp-promos-table-number-preauth',
  CHANGE_THE_DATE: 'paper-plp-promos-changethedate-preauth',
  PAPER_ADD_ONS: 'paper-plp-promos-paperaddons-preauth',
  BELLY_BAND: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
  VELLUM_JACKET: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
  WAX_SEAL: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
};

// The carousel tile shown on post-auth PLP
export const PLP_PROMO_MODULE_GROUP_TAGS_POST_AUTH: Record<
  SupportedLeadCardType,
  string | undefined
> = {
  MATCHING_SUITES: undefined, // Module isn't displayed on the matching suites page
  SAVE_THE_DATE: 'paper-plp-promos-savethedate-postauth',
  DIGITAL_SAVE_THE_DATE: undefined,
  INVITATION: 'paper-plp-promos-invitation-postauth',
  WEDDING_SHOWER_INVITATION: 'paper-plp-promos-wedding-shower-postauth',
  PLACE: 'paper-plp-promos-placecard-postauth',
  MENU: 'paper-plp-promos-menu-postauth',
  PROGRAM: 'paper-plp-promos-program-postauth',
  NAPKIN: 'paper-plp-promos-napkins-postauth',
  SIGNAGE: 'paper-plp-promos-weddingsigns-postauth',
  STICKER: 'paper-plp-promos-stickers-postauth',
  THANK_YOU: 'paper-plp-promos-thankyou-postauth',
  ENCLOSURE: undefined, // On the PLP, the type will always be DETAILS
  DETAILS: 'paper-plp-promos-enclosure-postauth',
  HOLIDAY: 'paper-plp-promos-holiday-postauth',
  TABLE_NUMBER: 'paper-plp-promos-table-number-postauth',
  CHANGE_THE_DATE: 'paper-plp-promos-changethedate-postauth',
  PAPER_ADD_ONS: 'paper-plp-promos-paperaddons-postauth',
  BELLY_BAND: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
  VELLUM_JACKET: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
  WAX_SEAL: undefined, // On the PLP, the type will always be PAPER_ADD_ONS
};

export const PLP_PROMO_MODULE_GROUP_TAG_POST_AUTH_LANDING_PAGE =
  'paper-plp-promos-universal-lp-postauth';
